import React, { Component } from "react";

const ServiceList = [
    {
        icon: '01',
        title: 'Digital.',
        description: 'Independent contractor support for digital-first work: web content, UI copy, digital assets, and production-ready exports—delivered per project.'
    },
    {
        icon: '02',
        title: 'Design.',
        description: 'Brand, layout and visual systems with a pragmatic production mindset. Scoped deliverables, clear iterations, and dependable handover.'
    },
    {
        icon: '03',
        title: 'Project-based.',
        description: 'Engage Stardust LAB per project or defined work package. You get senior execution and accountable delivery without long-term commitments.'
    },
]

class ServiceOne extends Component{
    render(){
        return(
            <React.Fragment>
                <div className="row">
                    {ServiceList.map( (val , i) => (
                        <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                            <div className="service service__style--1">
                                <div className="icon">
                                    <img src={`/assets/images/icons/icon-${val.icon}.png`} alt="Stardust LAB"/>
                                </div>
                                <div className="content">
                                    <h4 className="title">{val.title}</h4>
                                    <p>{val.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceOne;
